import type { UnknownOutputParams } from 'expo-router'

import type { TCommunityJoinParams } from '@/src/general/constants/routes'
import { getSessionInfo } from '@/src/general/utils/cookies/sessionInfo'
import { filterSearchParams } from '@/src/general/utils/filterSearchParams'

import type { TJoinCommunityPayload } from '../api/communityApi.types'

export const buildJoinPayload = (searchParams: UnknownOutputParams): TJoinCommunityPayload => {
  const { course, origin, pik, source } = filterSearchParams<TCommunityJoinParams>(searchParams)

  return {
    trackingSource: source,
    sponsorKey: pik,
    sessionInfo: {
      ...getSessionInfo(),
      eventOrigin: course === 'direct' ? `${origin}-direct-click` : origin,
    },
  }
}
